import { IRadioSelectProps, RadioSelect, radioSelectClasses } from '@private/components';
import { getBorderBase, getFontBase, getPrefixedVar } from '@private/payment';
import styled, { css } from 'styled-components';

import { ThemedElement } from 'utils/types';

export const CustomLabel = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
  margin-bottom: 10px;
`;

export const Label = styled.div``;

const getRadioStateTheme = (themePrefix: string[]) => {
  return css`
    ${radioSelectClasses.label} {
      ${getFontBase(themePrefix)};

      transition: all 0.3s ease;
    }

    ${radioSelectClasses.buttonIcon} {
      ${getBorderBase(themePrefix)};

      box-shadow: 0 0 0 ${getPrefixedVar(themePrefix, 'boxShadowWidth')}
        ${getPrefixedVar(themePrefix, 'boxShadowColor')};
      background: ${getPrefixedVar(themePrefix, 'bg')};
      transition: all 0.3s ease;
    }
  `;
};

export const getRadioSelectTheme = (themePrefix: string[]) => {
  return css`
    ${radioSelectClasses.groupLabel}, ${Label} {
      ${getFontBase([...themePrefix, 'groupLabel'])};

      transition: all 0.3s ease;
    }

    ${radioSelectClasses.radioContainer} {
      ${getRadioStateTheme([...themePrefix, 'notChecked', 'base'])};

      transition: all 0.3s ease;

      &:hover {
        ${getRadioStateTheme([...themePrefix, 'notChecked', 'hover'])};
      }

      &:active {
        ${getRadioStateTheme([...themePrefix, 'notChecked', 'pressed'])};
      }

      &[data-ischecked='true'] {
        ${getRadioStateTheme([...themePrefix, 'checked', 'base'])};

        &:hover {
          ${getRadioStateTheme([...themePrefix, 'checked', 'hover'])};
        }

        &:active {
          ${getRadioStateTheme([...themePrefix, 'checked', 'pressed'])};
        }
      }
    }

    &[data-is-disabled='true'] {
      ${getRadioStateTheme([...themePrefix, 'notChecked', 'disabled'])};
    }

    &[data-is-disabled='true'] ${radioSelectClasses.radioContainer}[data-ischecked='true'] {
      ${getRadioStateTheme([...themePrefix, 'checked', 'disabled'])};
    }
  `;
};

export default styled(RadioSelect)<ThemedElement<IRadioSelectProps>>`
  ${radioSelectClasses.label} {
    line-height: 144%;
  }

  ${radioSelectClasses.buttonIcon} {
    height: 20px;
    width: 20px;

    &::after {
      display: none;
    }
  }

  ${({ themePrefix = ['components', 'radioSelect'] }) =>
    getRadioSelectTheme(themePrefix)};
`;
